import axios, { AxiosRequestConfig } from 'axios'

import { ILog, LogParams, IProgresses } from '@/types/log'
import { UserRole } from '@/types/user'

export const createLog = async (log: ILog): Promise<ILog> => {
  try {
    const response = await axios.post<ILog>('logs', log)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.logs.createLog')
  }
}

export const getLogs = async (params: LogParams): Promise<ILog[]> => {
  const config: AxiosRequestConfig = {
    timeout: 1000 * 60 * 10, // 10 min
    params,
  }
  try {
    const response = await axios.get<ILog[]>('logs', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.logs.getLogs')
  }
}

export const getProgresses = async (
  date: number,
  userRole: UserRole,
  userId: number,
): Promise<IProgresses> => {
  const config: AxiosRequestConfig = {
    timeout: 1000 * 60 * 10, // 10 min
    params: {
      date,
      userRole,
      userId,
    },
  }
  try {
    const response = await axios.get<IProgresses>('logs/progresses', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.logs.getProgresses')
  }
}

export const getNewProgresses = async (
  date: number,
  userRole: UserRole,
  userId: number,
): Promise<IProgresses> => {
  const config: AxiosRequestConfig = {
    timeout: 1000 * 60 * 10, // 10 min
    params: {
      date,
      userRole,
      userId,
    },
  }
  try {
    const response = await axios.get<IProgresses>('logs/new-progresses', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.logs.getNewProgresses')
  }
}
